import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import environments from '@app/configs/environments';

export const subscriptionApi = createApi({
    reducerPath: 'subscriptionApi',
    baseQuery: fetchBaseQuery({
        baseUrl: environments.SUBSCRIPTION_API_URL
    }),
    endpoints: (builder) => ({
        submitContactUsForm: builder.mutation<any, any>({
            query: (body) => ({
                url: '/api/new-subscriber',
                method: 'POST',
                body
            })
        })
    })
});

export const { useSubmitContactUsFormMutation } = subscriptionApi;
